import Carousel from './carousel';

class Cards {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.carousel = new Carousel(self.elem, {
            cellSelector: '.cards__item',
            cellAlign: 'left',
            contain: false,
            groupCells: false,
            draggable: false,
            wrapAround: true,
            pageDots: false,
            adaptiveHeight: false,
            arrowShape: 'M14 0V18.69L3 34L14 49.518V68',
        }).init();

        return self;
    }
}

export default Cards;
